import { createAri, type Ari } from '@atlassian/jira-platform-ari';

export const createProjectAri = (cloudId: string, projectId?: number): Ari | null =>
	projectId == null
		? null
		: createAri({
				resourceOwner: 'jira',
				cloudId,
				resourceType: 'project',
				resourceId: `${projectId}`,
			});
